/**
 * An enum representing the type of calendar.
 *
 * @enum CalendarType
 * @platform iOS
 */
export var CalendarType;
(function (CalendarType) {
    /**
     *  This calendar is sync'd from either Mobile Me or tethered.
     */
    CalendarType[CalendarType["LOCAL"] = 0] = "LOCAL";
    /**
     * This calendar is from a CalDAV server.
     */
    CalendarType[CalendarType["CAL_DAV"] = 1] = "CAL_DAV";
    /**
     * This calendar comes from an Exchange server.
     */
    CalendarType[CalendarType["EXCHANGE"] = 2] = "EXCHANGE";
    /**
     * This is a locally subscribed calendar.
     */
    CalendarType[CalendarType["SUBSCRIPTION"] = 3] = "SUBSCRIPTION";
    /**
     * This is the built-in birthday calendar.
     */
    CalendarType[CalendarType["BIRTHDAY"] = 4] = "BIRTHDAY";
})(CalendarType || (CalendarType = {}));
//# sourceMappingURL=calendar-type.js.map